import { useParams } from 'react-router-dom'
import BackLink from '../components/BackLink'
import SessionReviewerResults from '../components/SessionReviewerResults'
import { ReviewerKeySchema } from '../schemas/sessionReviewers'

export default function SessionReviewerDetail() {
  const { projectId, reviewer } = useParams<{ projectId: string; reviewer: string }>()
  const key = ReviewerKeySchema.safeParse(reviewer)
  if (!projectId || !key.success) return <p role="alert">Reviewer not found.</p>
  return <main className="session-reviewer-page">
    <BackLink target={{ label: 'Overview', to: `/projects/${projectId}/overview` }} />
    <SessionReviewerResults key={`${projectId}:${key.data}`} projectId={projectId} reviewer={key.data} />
  </main>
}
